import nexo from '@tiendanube/nexo';

const nexoClient = nexo.create({
  clientId: '33018',
  log: true,
});

export default nexoClient;
